import React, { Component } from 'react';
import { toast } from 'react-toastify';

import FormError from 'components/FormError';
import LeaseList from 'components/LeaseList/LeaseList';
import Pagination from 'components/Pagination/Pagination';
import { getPrettyCarrier } from 'helpers/getCarrier';
import ConfirmModalV2 from 'components/modals/ConfirmModalV2';
import { prettyKey } from 'helpers/formatters';
import Spinner from 'components/Spinner';

export default class SubLeases extends Component {
  state = {
    loading: false,
    closeLeaseId: null,
  };

  componentDidMount() {
    this.fetchLeases();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.subId !== this.props.subId) {
      this.fetchLeases();
    }

    if (oldProps.page !== this.props.page) {
      this.fetchLeases();
    }
  }

  showCloseLease = (id) => {
    this.setState({ closeLeaseId: id });
  };

  hideCloseLease = () => {
    this.setState({ closeLeaseId: null });
  };

  fetchLeases() {
    const { fetchSubLeases, subId, page } = this.props;
    fetchSubLeases(subId, page);
  }

  handleUpdateField = (id, name, value) => {
    const { updateLease } = this.props;
    console.log(id, name, value);
    // return;

    if (['imei'].includes(name) && (!value || !value.trim())) {
      toast.error(`${prettyKey(name)} cannot be empty`);
      return;
    }

    this.setState({ loading: true });
    updateLease(id, { [name]: value })
      .then(() => {
        toast.success(`${prettyKey(name)} updated`);
        this.setState({ loading: false });
      })
      .catch((e) => {
        if (e.errors) {
          if (e.errors._error) {
            toast.error(<FormError error={e.errors._error} />);
            return;
          }

          let transformedError = e.errors;
          const keys = Object.keys(transformedError);
          keys.forEach((key) => {
            if (Array.isArray(transformedError[key])) {
              transformedError[key] = transformedError[key].join('; ');
            }
          });
          toast.error(<FormError error={transformedError} />);
        } else {
          toast.error(<FormError error={e} />);
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  closeLease = () => {
    const { closeLeaseId } = this.state;
    const { closeLease } = this.props;
    this.setState({ loading: true });
    return closeLease(closeLeaseId)
      .then(() => {
        this.hideCloseLease();
        toast.success('Lease Closed');
      })
      .catch((e) => {
        if (e.errors) {
          if (e.errors._error) {
            toast.error(<FormError error={e.errors._error} />);
            return;
          }

          let transformedError = e.errors;
          const keys = Object.keys(transformedError);
          keys.forEach((key) => {
            if (Array.isArray(transformedError[key])) {
              transformedError[key] = transformedError[key].join('; ');
            }
          });
          toast.error(<FormError error={transformedError} />);
        } else {
          toast.error(<FormError error={e} />);
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { subId, sub, leases, pageCount, page, pageUrl } = this.props;
    const { closeLeaseId, loading } = this.state;

    if (!leases) {
      return <div>Loading...</div>;
    }

    return (
      <div>
        <h1>{getPrettyCarrier(sub)} Subscription Leases</h1>
        <LeaseList
          leases={leases}
          showCloseLease={this.showCloseLease}
          handleUpdateField={this.handleUpdateField}
        />
        <Pagination
          count={pageCount}
          current={page}
          url={(pageNum) => pageUrl(subId, pageNum)}
        />
        <Spinner showLoader={loading} />
        <ConfirmModalV2
          isOpen={closeLeaseId}
          onClose={this.hideCloseLease}
          onConfirm={this.closeLease}
          loading={loading}
          confirmBtnText="Close"
          title="Close Lease"
          text="Are you sure you want to close lease?"
        />
      </div>
    );
  }
}
